import { primaryColor } from "../../../core/theme";

export const style = {
	override: {
		color: primaryColor,
		fontWeight: "bold",
	},
};
